<template>
  <section class="faq-section">
    <div class="container">
      <div class="faq-header">
        <h2 class="faq-title">FAQs</h2>
        <div class="title-underline"></div>
      </div>
      <div class="faq-list">
        <div 
          v-for="(faq, index) in faqs" 
          :key="index"
          class="faq-item"
          :class="{ 'active': activeFaq === index }"
        >
          <div class="faq-question" @click="toggleFaq(index)">
            <span>{{ faq.question }}</span>
            <i class="bi" :class="activeFaq === index ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
          </div>
          <transition name="fade">
            <div v-if="activeFaq === index" class="faq-answer">
              <p>{{ faq.answer }}</p>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "FaqSection",
  data() {
    return {
      activeFaq: null,
      faqs: [
        {
          question: "Quels sont les pays et wallet disponibles sur NOLIDO CASH ?",
          answer: "Nolido Cash est disponible dans 6 pays de la zone UEMOA : Sénégal, Mali, Burkina Faso, Bénin, Côte d'Ivoire et Togo. Nous supportons tous les wallets mobiles de ces pays."
        },
        {
          question: "Comment ça marche ?",
          answer: "Téléchargez l'application, inscrivez-vous avec votre numéro, ajoutez de l'argent sur votre compte, puis envoyez vers n'importe quel wallet mobile en quelques clics."
        },
        {
          question: "Vers quels pays NOLIDO CASH envoie-t-il de l'argent ?",
          answer: "Vous pouvez envoyer de l'argent vers tous les pays de la zone UEMOA où Nolido est présent."
        },
        {
          question: "Quel est le délai d'un transfert d'argent avec l'application Nolido Cash?",
          answer: "Nolido offre un service de paiement instantané. Nos services financiers sont disponibles 24h/24 et 7j/7. Votre bénéficiaire reçoit instantanément le rejet d'argent et peut déjà en faire usage en cas de perturbations, merci de contacter le service client."
        },
        {
          question: "Quels sont les frais de transactions ?",
          answer: "Nos frais sont compétitifs et transparents. Ils varient selon le montant et la destination. Consultez la grille tarifaire dans l'application pour plus de détails."
        },
        {
          question: "Quelles sont les limites de transactions autorisées sur NOLIDO CASH ?",
          answer: "Les limites varient selon le type de compte et le niveau de vérification. Consultez votre profil dans l'application pour voir vos limites actuelles."
        },
        {
          question: "Comment annuler une transaction ?",
          answer: "Les transactions instantanées ne peuvent pas être annulées une fois confirmées. Assurez-vous de vérifier toutes les informations avant de valider."
        },
        {
          question: "Comment supprimer mon compte Nolido cash ?",
          answer: "Pour supprimer votre compte, rendez-vous dans les paramètres de l'application ou contactez notre service client qui vous guidera dans la procédure."
        }
      ]
    };
  },
  methods: {
    toggleFaq(index) {
      this.activeFaq = this.activeFaq === index ? null : index;
    }
  }
};
</script>

<style scoped>
.faq-section {
  background: white;
  padding: 80px 0;
  position: relative;
}

.faq-header {
  text-align: center;
  margin-bottom: 3rem;
}

.faq-title {
  font-size: 3rem;
  font-weight: 800;
  color: #1A1A1A;
  margin-bottom: 1rem;
  letter-spacing: -0.02em;
}

.title-underline {
  width: 80px;
  height: 4px;
  background: #F5A847;
  margin: 0 auto;
  border-radius: 2px;
}

.faq-list {
  max-width: 800px;
  margin: 0 auto;
}

.faq-item {
  background: #F8F8F8;
  border-radius: 12px;
  margin-bottom: 1rem;
  overflow: hidden;
  transition: all 0.3s;
}

.faq-item.active {
  background: white;
  box-shadow: 0 4px 20px rgba(0,0,0,0.08);
}

.faq-question {
  padding: 1.5rem 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  user-select: none;
  transition: all 0.3s;
}

.faq-question:hover {
  background: rgba(245, 168, 71, 0.05);
}

.faq-question span {
  font-size: 1rem;
  font-weight: 600;
  color: #1A1A1A;
  flex: 1;
  padding-right: 1rem;
}

.faq-question i {
  font-size: 1.2rem;
  color: #1A1A1A;
  transition: transform 0.3s;
}

.faq-answer {
  padding: 0 2rem 1.5rem;
  animation: fadeIn 0.3s ease-in-out;
}

.faq-answer p {
  font-size: 0.95rem;
  color: #666;
  line-height: 1.6;
  margin: 0;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s, max-height 0.3s;
}

.fade-enter-from, .fade-leave-to {
  opacity: 0;
  max-height: 0;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 768px) {
  .faq-section {
    padding: 60px 0;
  }

  .faq-title {
    font-size: 2rem;
  }

  .faq-question {
    padding: 1.2rem 1.5rem;
  }

  .faq-question span {
    font-size: 0.95rem;
  }

  .faq-answer {
    padding: 0 1.5rem 1.2rem;
  }

  .faq-answer p {
    font-size: 0.9rem;
  }
}
</style>
